import { Modal, ModalBody, ModalCloseButton, ModalFooterButtons, ModalHeader, TextInput } from '@televet/kibble-ui';
import React, { ChangeEvent, useCallback, useState } from 'react';
import useClinicUser from 'shared/hooks/useClinicUser';
import { GetUserAppointmentGroupingsDocument, useCreateOneUserAppointmentGroupingMutation } from 'shared/types/graphql';

interface CreateAppointmentGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CreateAppointmentGroupModal = ({ isOpen, onClose }: CreateAppointmentGroupModalProps): JSX.Element => {
  const [label, setLabel] = useState('');
  const { currentClinicId, clinicUser } = useClinicUser();

  const [createOneUserAppointmentGrouping, { loading: isCreatingAppointmentGroup }] =
    useCreateOneUserAppointmentGroupingMutation({
      refetchQueries: [GetUserAppointmentGroupingsDocument],
    });

  const createAppointmentGroup = useCallback(async (): Promise<void> => {
    if (!label) return;
    if (currentClinicId && clinicUser?.id) {
      await createOneUserAppointmentGrouping({
        variables: {
          data: {
            label,
            clinic: { connect: { id: currentClinicId || '' } },
            user: { connect: { id: clinicUser?.id || '' } },
          },
        },
      });
      onClose();
      setLabel('');
    }
  }, [clinicUser?.id, createOneUserAppointmentGrouping, currentClinicId, label, onClose]);

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>): void => {
      if (e.key === 'Enter') {
        createAppointmentGroup();
      }
    },
    [createAppointmentGroup],
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalCloseButton />
      <ModalHeader>Create New Appointment Column</ModalHeader>
      <ModalBody>
        <TextInput
          onChange={(e: ChangeEvent<HTMLInputElement>): void => setLabel(e.target.value)}
          label="Column Label"
          autoFocus={true}
          onKeyDown={onKeyDown}
        />
      </ModalBody>
      <ModalFooterButtons
        submitText="Create Column"
        isLoading={isCreatingAppointmentGroup}
        onSubmit={createAppointmentGroup}
      />
    </Modal>
  );
};

export default CreateAppointmentGroupModal;
